module.exports = __webpack_public_path__ + "static/icon-fenqi.135b59c8.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-fenqi.png
// module id = 286
// module chunks = 2